// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Zh_EN","label":"styles_label__3R96l"};